import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg width={80} height={80} viewBox="0 0 80 80" fill="none" {...props}>
      <Circle opacity={0.1} cx={40} cy={40} r={40} fill="#00AB59" />
      <Circle opacity={0.5} cx={40} cy={40} r={32} fill="#00AB59" />
      <Circle cx={40} cy={40} r={24} fill="#00AB59" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.723 29.53a2.4 2.4 0 01-.053 3.394l-16.5 16a2.4 2.4 0 01-3.341 0l-7.5-7.273a2.4 2.4 0 113.341-3.446l5.83 5.653 14.829-14.38a2.4 2.4 0 013.394.052z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
